export default "__VITE_ASSET__DsHhlj3I__"